import { render, staticRenderFns } from "./AvaliacaoPsicossocialBemVindo.vue?vue&type=template&id=390c4685&scoped=true&"
import script from "./AvaliacaoPsicossocialBemVindo.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoPsicossocialBemVindo.vue?vue&type=script&lang=js&"
import style0 from "./AvaliacaoPsicossocialBemVindo.vue?vue&type=style&index=0&id=390c4685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c4685",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VDialog,VIcon,VProgressCircular,VRow})
